import React, { useState } from "react";
import CoreButton from "../../../../app/core/components/CoreButton/CoreButton";
import CoreModal from "../../../../app/core/components/CoreModal/CoreModal";
import CoreTabBar from "../../../../app/core/components/CoreTabBar/CoreTabBar";
import CoreSpinner from "../../../../app/core/components/CoreSpinner/CoreSpinner";
import { useGetServicesQuery } from "../../../api/admin/ServiziApi";
import { t } from "i18next";
import CoreRequestServices from "../../../../app/core/components/CoreRequestServices/CoreRequestServices";
import { useSelector } from "react-redux";
import { TABS_SERVICES } from "../../../../utils/constants/tab_bar";
import AltriServiziPage from "../../AltriServizi/AltriServiziPage";

const ServiziStudioPage = () => {
  const [openRequestServiceModal, setOpenRequestServiceModal] = useState(false);
  const [selectedService, setSelectedService] = useState();
  const [selectedTab, setSelectedTab] = useState("services");

  const { data: services, isLoading } = useGetServicesQuery({
    startRow: 0,
    endRow: 100,
  });

  const appConfig = useSelector((state) => state.app.appConfig);

  const handleOpen = (service) => {
    setSelectedService(service);
    setOpenRequestServiceModal(true);
  };

  const handleClose = () => {
    setOpenRequestServiceModal(false);
    setSelectedService();
  };

  return (
    <>
      {isLoading ? (
        <CoreSpinner />
      ) : (
        <div className="w-full">
          <div className="flex items-center ">
            <h2 className="font-bold" style={{ width: "200px" }}>
              {selectedTab === "services"
                ? `${t("Services")}`
                : `${t("OtherServices")}`}
            </h2>
            {appConfig?.modules?.services?.otherServices && (
              <CoreTabBar
                tab={TABS_SERVICES()}
                setSelectedTab={setSelectedTab}
              />
            )}
          </div>
          {selectedTab === "services" && (
            <div>
              {services?.Data?.items?.map((el, idx) => (
                <div className="flex py-5 items-center space-x-12" key={idx}>
                  <div className="w-28">
                    {el.iconUrl ? (
                      <img
                        alt={idx}
                        src={el.iconUrl}
                        className="w-full h-full"
                      />
                    ) : (
                      <p className="text-gray">No logo</p>
                    )}
                  </div>
                  <div className="w-4/12">
                    <h3 className="m-0">{el.name}</h3>
                    <p className="m-0">{el.description}</p>
                  </div>
                  <CoreButton
                    testo={`${t("ActiveForUser")}`}
                    className={"btn-round"}
                    onClick={() => handleOpen(el)}
                  />
                </div>
              ))}
            </div>
          )}
          {selectedTab === "otherservices" && <AltriServiziPage />}
          <CoreModal
            width={700}
            height={600}
            state={openRequestServiceModal}
            onClose={handleClose}
            component={
              <CoreRequestServices
                onClose={handleClose}
                selectedService={selectedService}
              />
            }
          />
        </div>
      )}
    </>
  );
};

export default ServiziStudioPage;
